import { z } from "zod";

export const PaginationSchema = z.object({
  page: z.number(),
  pages: z
    .number()
    .nullable()
    .transform(val => val ?? 1),
  size: z
    .number()
    .nullable()
    .transform(val => val ?? 10),
  total: z.number(),
});
